import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { axiosInstance } from 'api/axios-instance';
import { newClients } from 'types/new-clients';
export interface ClientsListParams extends PaginatedRequestParams {
  Name?: string;
  Email?: string;
  PhoneNumber?: string;
  retry?: boolean;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}
export type fetchFalg = {
  Flag: string;
};
export type NewClientsResponse = PaginatedResponse<newClients>;

export const NewClientsApiService = () => {
  const createClients = async (formData: FormData) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL}/Client/CreateClient`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const getClients = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<NewClientsResponse>({
      ...callConfig,
      endpoint: `/Client/GetClientList`,
      params,
    });

    return response.data;
  };
  const dropDownByFlag = async (
    Flag: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;

    const response = await apiClient<NewClientsResponse>({
      ...callConfig,
      endpoint: `${baseURL}/Dropdown/Get?Flag=${Flag}`,
    });

    return response;
  };
  const getCustomizeAccess = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<NewClientsResponse>({
      ...callConfig,
      endpoint: `/Client/GetClientServices`,
      params,
    });

    return response.data;
  };

  return {
    getClients,
    createClients,
    dropDownByFlag,
    getCustomizeAccess,
  };
};
